import { BoxProps } from '@material-ui/core'

export const center: BoxProps['sx'] = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
}
